export default function anonymous(props
) {
var out='<img class="'+(props.styles.logoImage)+'" aria-label="'+(props.texts.label)+'"/>';return out;
}